jQuery(document).ready(function($){
  jQuery('.slider').slick({
    autoplay: true,  // Enable auto-play
    autoplaySpeed: 5000,  // Set the interval for auto-play (in ms)
    dots: true,  // Show navigation dots
    arrows: true,  // Show next/previous arrows
    fade: true,  // Apply a fade effect between slides
    speed: 1000,  // Set the speed of the transition (in ms)
    pauseOnHover: true,  // Pause the slider when hovered
    infinite: true,  // Enable infinite looping of slides
  });
});

$(document).ready(function () {
  $('.collections-slider ul').slick({
    slidesToShow: 4, // Number of slides visible
    slidesToScroll: 1, // Number of slides to scroll
    infinite: true, // Infinite scrolling
    responsive: [
        {
        breakpoint: 1200, // For screens smaller than 1200px
        settings: {
          slidesToShow: 3 // Show 3 slides at this breakpoint
        }
      },
      {
        breakpoint: 768, // Mobile breakpoint
        settings: {
          slidesToShow: 1 // Show only one slide on smaller screens
        }
      }
    ]
  });
});
// document.querySelector('.search-btn').addEventListener('click', function () {
//   const searchInput = document.querySelector('.search-input');
//   searchInput.style.display = searchInput.style.display === 'block' ? 'none' : 'block';
// });